import { screenshotShows } from "@/mocks/chigua";

export default function ShotsSection() {
  return (
    <section id="shots" className="scroll-mt-28 bg-paper">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6">
        <div className="mb-9 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-peach px-3 py-1 text-xs font-bold text-ember">
              <i className="ri-collage-line" />
              图文并重 · 按节点对照
            </span>
            <h2 className="mt-3 font-display-x text-3xl font-black md:text-4xl">
              截图合集 · 关键节点慢慢看
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink/60 md:text-base">
              把同一事件的截图按时间线整理成合集，逐张编号、标好出处，方便对照求证、快速出图做传播。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {screenshotShows.map((s, i) => (
            <a
              key={s.title}
              href="#shots"
              className="group relative overflow-hidden rounded-2xl bg-paper ring-1 ring-sand/60"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden bg-sand">
                <img
                  src={s.cover}
                  alt={s.title}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 transition group-hover:opacity-100" />
                <span className="absolute bottom-3 left-3 rounded-full bg-paper/85 px-2.5 py-1 text-xs font-bold text-ink">
                  {s.count}
                </span>
                {i === 0 && (
                  <span className="absolute right-3 top-3 rounded-full bg-ember px-2.5 py-1 text-[11px] font-bold text-cream">
                    最新
                  </span>
                )}
              </div>
              <div className="flex items-center justify-between gap-2 p-4">
                <h3 className="text-sm font-bold leading-snug text-ink">{s.title}</h3>
                <i className="ri-arrow-right-circle-line shrink-0 text-lg text-ember" />
              </div>
            </a>
          ))}
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-4 rounded-2xl bg-cream px-6 py-5 ring-1 ring-sand/60 sm:flex-row">
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber/20 text-amber">
              <i className="ri-time-line text-xl" />
            </span>
            <p className="text-sm text-ink/70">
              截图按<strong className="text-ink">起 · 涨 · 热 · 顶 · 散</strong>五个阶段归档，
              每一张都可溯源。
            </p>
          </div>
          <a
            href="#shots"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-ember px-5 py-2.5 text-sm font-bold text-cream transition hover:bg-[#c74423]"
          >
            <i className="ri-download-cloud-2-line" />
            进入截图合集
          </a>
        </div>
      </div>
    </section>
  );
}